import { ThemeProvider } from '@material-ui/core/styles'
import { DASHBOARD } from 'constants/breakpoints'
import { useMediaQuery } from 'react-responsive'

import withResolution from 'hoc/withResolution'
import DefaultImageBlock from './common/DefaultImageBlock'
import Actions from './common/Actions'

import { MEMBER_INFO_COLLAPSE_BOUND } from 'constants/breakpoints'
import overrideTheme from 'theming/overrides/dashboard/visitPanel'
import { observer, Observer } from 'mobx-react-lite'
import MenuIcon from '@ui-components-3/icons/lib/solid/Bars'
import SideNavSingleton from 'singletons/SideNav'
import { isSuccessVisit } from 'constants/visit-types'
import { ReactNode } from 'react'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import { useSelectCrisisStream } from 'hooks/crisis/useCrisisStream'

type VisitPanelProps = {
  // TODO - add type for store
  store: any
  leftBlock?: ReactNode
  isMobile?: boolean
  scrollContainerToTop: () => void
}

const VisitPanel = ({ store, leftBlock, isMobile, scrollContainerToTop }: VisitPanelProps) => {
  const isTabletOrMobile = useMediaQuery({ query: `(max-width: ${DASHBOARD}px)` })

  const handleArrowClick = () => {
    store.setMemberPanelVisibility(!store.memberPanelVisible)
    !store.memberPanelVisible && scrollContainerToTop()
  }

  const { isCrisis } = useSelectCrisisStream()

  const renderMemberBlock = (
    <Observer>
      {() =>
        store.memberPanelVisible && (
          <>
            <h4 className="typography-body-xxl font-medium" onDoubleClick={() => console.log(store)}>
              <Observer>{() => store.visit.memberFullName}</Observer>
            </h4>
            <div className="flex items-center gap-2 flex-wrap">
              <Observer>
                {() =>
                  store.visit.memberGroupType && (
                    <span className="typography-small text-primary-700 font-semibold bg-primary-200 rounded-full px-2 py-1">
                      <Observer>{() => store.visit.memberGroupType}</Observer>
                    </span>
                  )
                }
              </Observer>
              {!!isCrisis && (
                <span className="typography-small text-white font-semibold bg-fuchsia-700 rounded-full px-2 py-1">
                  Crisis Line Caller
                </span>
              )}
              <Observer>
                {() =>
                  !!store.visit.shouldShowNewPatientAllergiesBanner &&
                  !!store.visit.allMemberAllergies?.length && (
                    <span className="typography-small text-fuchsia-700 font-semibold bg-fuchsia-100 rounded-full px-2 py-1">
                      Allergy
                    </span>
                  )
                }
              </Observer>
              <h5 className="typography-body-l text-neutral-500 font-medium">
                <Observer>{() => store.visit.panelPrivateInfo}</Observer>
              </h5>
            </div>
          </>
        )
      }
    </Observer>
  )

  return (
    <ThemeProvider theme={overrideTheme}>
      <div className="flex items-stretch">
        {SideNavSingleton.isOpen || isTabletOrMobile ? null : (
          <div className="min-w-[84px] flex items-center justify-center bg-primary-800 self-stretch">
            <button
              type="button"
              onClick={() => SideNavSingleton.setIsOpen(true)}
              className="btn-tiny btn-primary-borderless"
            >
              <MenuIcon className="text-white" aria-label="Open navigation panel" />
            </button>
          </div>
        )}
        <div
          className={classNames(
            'flex-1 flex flex-col items-stretch shadow-[0px_1px_4px_rgba(0, 0, 0, 0.1)] gap-x-4',
            SideNavSingleton.isOpen ? 'xl:flex-row xl:items-center' : 'lg:flex-row lg:items-center',
          )}
        >
          <div className="flex items-center flex-grow-0 shrink basis-0 self-stretch gap-4">
            {leftBlock || (
              <Observer>
                {() => (
                  <DefaultImageBlock
                    modality={store.visit.modality}
                    handleArrowClick={handleArrowClick}
                    isMobile={isMobile}
                    memberPanelVisible={store.memberPanelVisible}
                    isSuccess={isSuccessVisit(store.visit.visitType)}
                  />
                )}
              </Observer>
            )}
            <div
              className={classNames(
                'flex flex-1 min-h-[88px] flex-col justify-center',
                SideNavSingleton.isOpen ? 'xl:hidden' : 'lg:hidden',
              )}
            >
              {renderMemberBlock}
            </div>
          </div>

          <Observer>
            {() =>
              store.memberPanelVisible && (
                <div
                  className={classNames(
                    'flex flex-col lg:flex-row items-stretch lg:items-center gap-4 flex-grow py-2  px-6',
                    SideNavSingleton.isOpen ? 'xl:py-4 xl:px-0' : 'lg:py-4 lg:px-0',
                  )}
                >
                  <div className={classNames('hidden flex-1', SideNavSingleton.isOpen ? 'xl:block' : 'lg:block')}>
                    {renderMemberBlock}
                  </div>
                  <Actions store={store} />
                </div>
              )
            }
          </Observer>
        </div>
      </div>
    </ThemeProvider>
  )
}

export default withResolution(MEMBER_INFO_COLLAPSE_BOUND)(observer(VisitPanel))
